"use strict";
module.exports = function () {
    return {
        restrict: 'AE',
        template: require('./languageSwitch.html'),
        controller: require('./languageSwitchCtrl'),
        priority: 9999,
        scope: {
            languages: '='
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/directives/languageSwitch/languageSwitchDirective.js
// module id = 314
// module chunks = 0